<template>
  <div class="footer">
    <div class="container">
      <div
        class="gotop"
        @click="scrollTop"
      >
        <img src="../assets/img/arrow-white.svg">
        <span>Oldal Tetejére!</span>
      </div>
      <div class="nextforbes">
        <a href="https://forbes.hu">Tovább a <img
            src="../assets/img/forbes-foo.svg"
            alt="Forbes"
            class="forbeslogo"
          >-ra <img
            src="../assets/img/arrow-white.svg"
            class="arrow"
          ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    scrollTop() {
      // window.scrollTo(0, 0);
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: 0,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  background-color: #f0271d;
  color: #fff;
}
.container {
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  text-transform: uppercase;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 500;
  align-items: end;
  padding: 10px 30px;
  letter-spacing: 1px;
}
.gotop {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  cursor: pointer;
  display: grid;
  display: -ms-grid;
  grid-template-columns: auto;
  -ms-grid-columns: 1fr;
  grid-template-rows: auto auto;
  -ms-grid-rows: auto auto;
  justify-content: center;
}
.gotop img {
  width: 20px;
  transform: rotate(-90deg);
  grid-column: 1/2;
  -ms-grid-column: 1;
  grid-row: 1/2;
  -ms-grid-row: 1;
  justify-self: center;
  margin: 5px auto 10px auto;
  transition-duration: 0.5s;
}
.gotop:hover img {
  transform: translateY(-5px) rotate(-90deg);
  transition-duration: 1s;
}
.gotop span {
  grid-column: 1/2;
  -ms-grid-column: 1;
  grid-row: 2/3;
  -ms-grid-row: 2;
  display: block;
  text-align: center;
}
.nextforbes {
  grid-column: 3/4;
  grid-row: 1/2;
  -ms-grid-column: 3;
  -ms-grid-row: 1;
  justify-self: flex-end;
  text-align: right;
}
.nextforbes a {
  color: #fff;
  text-decoration: none;
}
.nextforbes .forbeslogo {
  height: 20px;
}
.nextforbes .arrow {
  width: 20px;
  margin-left: 10px;
  transition-duration: 0.5s;
}
.nextforbes:hover .arrow {
  transform: translateX(+5px);
  transition-duration: 1s;
}
</style>
